module.exports = "/build/web/svg/business.2ecec34deec86f288b27b65470bda992.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/business.svg
// module id = 147
// module chunks = 24